const c = {
  name: "Global",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,39.9C8.4,39.4,0,30.7,0,20C0,9.3,8.4,0.6,19,0.1C19.4,0,19.7,0,20,0c0.3,0,0.6,0,1,0.1
			C31.6,0.6,40,9.3,40,20c0,10.7-8.4,19.4-19,19.9c-0.3,0-0.6,0.1-1,0.1C19.7,40,19.4,40,19,39.9z M27.8,11H21v8h8
			C28.9,16.1,28.5,13.4,27.8,11z M19,11h-6.8c-0.7,2.4-1.1,5.1-1.2,8h8V11z M21,9h6.1c-0.3-0.7-0.6-1.4-0.9-2
			c-1.5-2.8-3.3-4.5-5.2-4.9V9z M19,2.1c-1.9,0.4-3.7,2.1-5.2,4.9c-0.3,0.6-0.6,1.3-0.9,2H19V2.1z M19,21h-8c0.1,2.9,0.5,5.6,1.2,8
			H19V21z M19,31h-6.1c0.3,0.7,0.6,1.4,0.9,2c1.5,2.8,3.3,4.5,5.2,4.9V31z M21,37.9c1.9-0.4,3.7-2.1,5.2-4.9c0.3-0.6,0.6-1.3,0.9-2
			H21V37.9z M21,29h6.8c0.7-2.4,1.1-5.1,1.2-8h-8V29z M29.9,11c0.7,2.4,1.1,5.1,1.1,8h7c-0.2-2.9-1-5.6-2.4-8H29.9z M34.2,9
			c-2.1-2.7-5-4.9-8.4-6C26.7,3.9,27.4,5,28,6.1C28.4,7,28.9,8,29.2,9H34.2z M10.8,9c0.4-1,0.8-2,1.3-2.9C12.6,5,13.3,3.9,14.1,3
			c-3.3,1.2-6.2,3.3-8.4,6H10.8z M4.4,11C3,13.4,2.2,16.1,2,19h7c0.1-2.9,0.5-5.6,1.1-8H4.4z M28,33.9c-0.6,1.1-1.3,2.2-2.1,3.1
			c3.3-1.2,6.2-3.3,8.4-6h-5C28.9,32,28.4,33,28,33.9z M29.9,29h5.7c1.4-2.4,2.2-5.1,2.4-8h-7C30.9,23.8,30.5,26.6,29.9,29z M9,21H2
			c0.2,2.9,1,5.6,2.4,8h5.7C9.5,26.6,9.1,23.8,9,21z M14.1,37c-0.8-0.9-1.5-1.9-2.1-3.1C11.6,33,11.1,32,10.8,31h-5
			C7.9,33.7,10.8,35.8,14.1,37z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Global
};
